export default "__VITE_ASSET__CKDx1pYj__"